"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components")); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var Content = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "Content",
  componentId: "sc-npj4gl-0"
})(["margin-top:2.5rem;"]);

var _default = Content;
exports["default"] = _default;